import { Text, TextVariant } from '@naf/text';
import React from 'react';
import { ChevronRight } from '@styled-icons/material/ChevronRight';
import { useTrackElementClick } from '@utils/Tracking/ElementClick/TrackElementClick';
import type { Props } from './FAQLink.utils';
import { getIcon } from './FAQLink.utils';
import * as S from './FAQLink.styles';

const FAQLink = ({ faq }: Props) => {
  const trackElementClick = useTrackElementClick();
  const url = `/kundeservice/${faq.slug?.current || ''}`;

  return (
    <S.LinkWrapper
      to={url}
      onClick={() => trackElementClick({ elementType: 'FAQLink', linkText: faq.title, linkUrl: url })}
    >
      {getIcon(faq.icon)}
      <Text variant={TextVariant.Header3}>{faq.title}</Text>
      <ChevronRight height={24} width={24} />
    </S.LinkWrapper>
  );
};

export default FAQLink;
